import React, { useState } from 'react';
import { Container, Paper, Tabs, Tab, Box } from '@mui/material';
import FoundationInputForm from './FoundationInputForm';
import FoundationResults from './FoundationResults';

const FoundationAnalysis = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [analysisResults, setAnalysisResults] = useState(null);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleAnalysisComplete = (results) => {
    setAnalysisResults(results);
    setActiveTab(1); // Switch to results tab
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 3 }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange}>
            <Tab label="Foundation Input" />
            <Tab label="Analysis Results" disabled={!analysisResults} />
          </Tabs>
        </Box>

        <Box sx={{ mt: 3 }}>
          {activeTab === 0 && (
            <FoundationInputForm onAnalysisComplete={handleAnalysisComplete} />
          )}

          {activeTab === 1 && analysisResults && (
            <FoundationResults results={analysisResults} />
          )}
        </Box>
      </Paper>
    </Container>
  );
};

export default FoundationAnalysis;
